import { atom } from 'jotai';

import { loadsTabDetailQueryAtom } from '../_graphql/queryLoadsTabDetail';
import { loadsTabListQueryAtom } from '../_graphql/queryLoadsTabList';
import { loadsTabSoLineItemsQueryAtom } from '../_graphql/queryLoadsTabSalesOrderLineItems';
import { salesOrderLineItemsQueryAtom } from '../_graphql/querySalesOrderLineItems';

// 🟣🟣🟣 ATOMS - Loads Tab
export const $loadInfoFocusSignal = atom<'salesOrder' | 'booking' | null>(null);
export const $materialCellFocusSignal = atom<string | null>(null);

export const $loadsTabContext = atom<{
  bookingId?: string;
  salesOrderId?: string;
  purchaseOrderId?: string;
  entityType: 'booking' | 'salesOrder' | 'purchaseOrder';
} | null>(null);

export const $selectedLoadId = atom<string | null>(null);

export const $remoteLoads = loadsTabListQueryAtom(() => ({
  variables: {} as never,
  lazy: true,
}));

export const $loadsTabDetail = loadsTabDetailQueryAtom((get) => {
  const selectedLoadId = get($selectedLoadId);
  return {
    variables: { id: selectedLoadId ?? '' },
    skip: !selectedLoadId,
  };
});

export const $salesOrderLineItems = salesOrderLineItemsQueryAtom(() => ({
  variables: {} as never,
  lazy: true,
}));

export const $loadsTabSoLineItems = loadsTabSoLineItemsQueryAtom(() => ({
  variables: {} as never,
  lazy: true,
}));
